import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import Nav from "@/components/Nav";
import { Eye, EyeOff } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Nav variant="marketing" />
      <div className="max-w-md mx-auto pt-20 px-6">
        <div className="overline">Sign in</div>
        <h1 className="font-serif-display text-4xl text-[#1E1B4B] mt-2">Welcome back.</h1>
        <p className="mt-3 text-stone-600">Continue your journey toward the right marriage decision.</p>
        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-stone-500">Email</label>
            <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full border border-stone-300 rounded-xl px-4 py-3 bg-white focus:border-[#1E1B4B]" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-stone-500">Password</label>
            <div className="relative mt-2">
              <input
                data-testid="login-password-input"
                type={showPw ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-stone-300 rounded-xl px-4 py-3 pr-12 bg-white focus:border-[#1E1B4B]"
              />
              <button
                type="button"
                data-testid="login-password-toggle"
                onClick={() => setShowPw((v) => !v)}
                aria-label={showPw ? "Hide password" : "Show password"}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-stone-500 hover:text-[#1E1B4B]"
              >
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button data-testid="login-submit-btn" disabled={loading}
            className="btn-pill w-full text-white py-3.5" style={{ background: "#1E1B4B" }}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="mt-8 text-sm text-stone-500">New here? <Link to="/signup" className="text-[#1E1B4B] underline underline-offset-4">Create an account</Link></p>
      </div>
    </div>
  );
}
